import { useEffect, useState } from "react";
import { matchesLinkedRule } from "../../services/menu/linkedRules";
import { listMenuProductChoices } from "../../services/supabase/menuService";

export default function useLinkedProductChoices({
  menuId, categoryId, subcategoryId, products, remote,
}) {
  const [result, setResult] = useState(null);
  const [retry, setRetry] = useState(0);
  const scope = JSON.stringify([menuId, categoryId, subcategoryId || ""]);
  const needsRemote = Boolean(remote && menuId && categoryId);

  useEffect(() => {
    if (!needsRemote) return undefined;
    let active = true;
    setResult({ scope, loading: true, products: [], error: "" });
    listMenuProductChoices(menuId, categoryId, subcategoryId)
      .then((choices) => {
        if (active) setResult({ scope, products: choices, loading: false, error: "" });
      })
      .catch((error) => {
        if (active) setResult({ scope, products: [], loading: false,
          error: error.message || "No se pudieron cargar los platos de este grupo." });
      });
    return () => { active = false; };
  }, [needsRemote, menuId, categoryId, subcategoryId, scope, products, retry]);

  const rule = { sourceCategoryId: categoryId, sourceSubcategoryId: subcategoryId };
  const currentResult = result?.scope === scope ? result : null;
  const choices = needsRemote ? currentResult?.products || [] : products;
  return {
    products: categoryId ? (choices || []).filter((product) => matchesLinkedRule(rule, product))
      .map((product) => ({ ...product, id: String(product.id || product.productId || "").trim(),
        nombre: product.nombre || product.name || "Plato sin nombre" })).filter((product) => product.id) : [],
    loading: needsRemote && (!currentResult || currentResult.loading),
    error: needsRemote ? currentResult?.error || "" : "",
    refresh: () => setRetry((value) => value + 1),
  };
}
